module.exports = __webpack_public_path__ + "static/img/part_1_green.d68e10ec.png";